import { Component } from '@angular/core';

interface ArticleFeature {
    text: string;
}

interface ArticleTag {
    label: string;
}

interface GalleryImage {
    image: string;
    alt: string;
}

@Component({
    selector: 'app-fens2026',
    templateUrl: './fens2026.component.html',
    styleUrls: ['./fens2026.component.scss']
})
export class Fens2026Component {

    /* ==========================================
        Hero
    ========================================== */

    heroImage = '/assets/img/redesign/news/stand01.jpg';

    heroAlt = 'Article Image';

    /* ==========================================
        Article Meta
    ========================================== */

    publishDate = '01 Aug 2026';

    author = 'Richard';

    comments = 357;

    readingTime = '3 min Read';

    /* ==========================================
        Title
    ========================================== */

    title = 'FENS 2026';

    /* ==========================================
        Introduction
    ========================================== */

    introduction: string[] = [

        'This is what my time at FENS Forum 2026 in Barcelona looked like. 8,000 neuroscientists under one roof. Europe’s largest neuroscience conference. I was there to present Althea Soft and talk about how AI can connect the systems and teams that still operate in silos within hospitals today. But I came away with much more than that: the talks, the people I met, and the opportunity to see first-hand where science is heading, and how, sooner or later, it will change the way we care for mental health. During our recent showcase, the medical community was incredibly impressed by our AI Collaboration Platform and our new AI Hologram Assistant.',

        // 'We demonstrated how these advanced tools empower doctors, psychologists, psychiatrists, and neurologists to detect early-stage mental health conditions and neurodegenerative diseases, such as Alzheimer’s, Borderline Personality Disorder (BPD), dementia, ADHD and other mental related diseases.',

        // 'By seamlessly analyzing brain scans, vital signs, and comprehensive electronic health records (including symptoms, allergies, and medication side effects), our technology provides clinicians with deep, actionable insights for early intervention.',

        'We are proud to be at the forefront of transforming patient care through artificial intelligence.'
    ];

    /* ==========================================
        Quote
    ========================================== */

    quote = 'Thanks to the entire FENS and Spanish Society for Neuroscience teams for making an event like this happens in Barcelona.';

    quoteAuthor = 'Richard';

    /* ==========================================
        Features
    ========================================== */

    featuresTitle = 'We presented our Advance AI Platform';

    features: ArticleFeature[] = [

        {
            text: 'Empower doctors, psychologists, psychiatrists, and neurologists to detect early-stage mental health conditions and neurodegenerative diseases'
        },
        {
            text: 'Analyze brain scans, vital signs, and comprehensive electronic health records (including symptoms, allergies, and medication side effects), our technology provides clinicians with deep, actionable insights for early intervention'
        },
        {
            text: 'Patented AI Agents for mental health diseases including Alzheimer’s, Borderline Personality Disorder (BPD), dementia, ADHD and other mental related diseases',

        },
        {
            text: 'AI Assistance with Voice-Activated Workflows, Instant Dictation Engine, Intelligent Diagnostic Predictions and Automated Risk Assessments. Real-time clinical notes into structured records instantly during patient sessions, Switch seamlessly between complex patient metrics, charts, and image views using only vocal cues.'
        }

    ];

    featureImage = '/assets/img/redesign/product01.jpg';

    featureImageAlt = 'Article Feature';

    /* ==========================================
        Gallery
    ========================================== */

    gallery: GalleryImage[] = [

        {
            image: '/assets/img/redesign/product02.jpg',
            alt: 'Gallery Image 1'
        },
        {
            image: '/assets/img/redesign/product03.jpg',
            alt: 'Gallery Image 2'
        }

    ];

    /* ==========================================
        Conclusion
    ========================================== */

    conclusion = 'Althea Soft LTD empowers hospitals, mental health clinics, and regulated care environments with an advanced, hands-free AI platform that seamlessly combines real-time monitoring and voice-activated workflow assistance with sophisticated neuroimaging brain analysis—enabling early detection of psychiatric risks, faster clinical responses, predictive risk assessments, and the reliable prevention of critical events for safer, proactive mental healthcare.';

    /* ==========================================
        Tags
    ========================================== */

    tags: ArticleTag[] = [

        {
            label: 'Healthcare'
        },
        {
            label: 'Mental health diseases'
        },
        {
            label: 'AI Assistance'
        },
        {
            label: 'Patent AI Agents'
        }

    ];

    /* ==========================================
        Share
    ========================================== */

    shareFacebook = '#';

    shareLinkedin = '#';

    /* ==========================================
        TrackBy
    ========================================== */

    trackByIndex(index: number): number {

        return index;

    }

    trackByTag(index: number, tag: ArticleTag): string {

        return tag.label;

    }

}